import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../../customs/endpoints";
import {CommonResponse} from "../../customs/_models/Response";
import {Observable, catchError, of, tap} from "rxjs";
import {OT_DTO} from "../../customs/_models/OT_DTO";
import {AnalyseDTO} from "../../customs/_models/analyse.dtos";
import {DialogService} from "../../customs/_modal/dialog.service";
import {SampleDTO} from "../../customs/_models/sampleDTO";
import {
    MatTableDataSource, MatTableModule
} from "@angular/material/table";
import { SampleAnalyseResponseDto } from '../sample-service/sample.service';


export interface AnalyseResult {
  id: number;
  refAnalyse: string;
  startDate: string;
  endDate?: string;
  statut: number;
  parameterName:string;
  commentaire?: string;
  sampleId?: number;
  sampleCode:string;
  status:string;
  appUserName:string;
  parameterId?: number;
  substanceId?: number;
  appUserId?: number;
  poids?: number;
  resultatBrute?: number;
  resultatFinale?: number;
  unit?: string;
  dateMesure?: string;
  valide?: boolean;
  formuleId?: number;
  createdById?: number;
  creationDate?: string;
  updateDate?: string;
  lq?:number;
}
export interface SampleWithAnalyses {
  sampleId: number;
  sampleCode: string;
  refAnalyse: string;
  formuleName: string;
  statut: string;

  results: AnalyseResult[];

  // 🔥 خصائص UI
  resultsCount: number;
  resultsDataSource: MatTableDataSource<AnalyseResult>;
}
@Injectable({
    providedIn: 'root'
})
export class AnalyseService {


    constructor(private http: HttpClient,
                private endPoint: Endpoints,
                private dialogService: DialogService,) {
    }

 

  // Récupérer tous les analyse résultat
  getAllAnalyseResults(): Observable<AnalyseResult[]> {
    return this.http.get<AnalyseResult[]>(`${this.endPoint.analyseR_base_endpoint}/all`);
  }

    getSamplesWithAnalyses(): Observable<SampleWithAnalyses[]> {
    return this.http.get<SampleWithAnalyses[]>(
      `${this.endPoint.analyseR_base_endpoint}/samples-with-analyses`
    );
  }
    validateResultsByTechnicien(sampleIds: number[]): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${this.endPoint.analyseR_base_endpoint}/validate-by-technicien`,
      sampleIds
    );
  }
reviseResults(sampleIds: number[]): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${this.endPoint.analyseR_base_endpoint}/revise`,
      sampleIds
    );
  }
  
     validateResultsByRespQL(sampleIds: number[]): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${this.endPoint.analyseR_base_endpoint}/validate-by-res`,
      sampleIds
    );
  }
 validateSample(sampleId: number): Observable<void> {
    return this.http.put<void>(
      `${this.endPoint.analyseR_base_endpoint}/samples/${sampleId}/validate`,
      {}
    );
  }
    generateOT(selctedSamples: SampleDTO[]) : Observable<CommonResponse | null>  {
        if (selctedSamples.length < 1) {
            this.dialogService.openDangerDialog('Aucun échantillon selectionne');
            return of(null)
        }
        let dto: OT_DTO[] = []
        selctedSamples.forEach(
            (sample) => {
                dto.push({sampleId: sample.id, typeAnalyseId: sample.idAT!})
            }
        )
        let typeAnalyseId: number = dto[0].typeAnalyseId
        for (const element of dto) {
            if (typeAnalyseId == -1) {
                this.dialogService.openDangerDialog("Type analyse n'exists pas dans les échantillions");
                return of(null)
            }
            if (element.typeAnalyseId != typeAnalyseId) {
                this.dialogService.openDangerDialog('Les échantillons doivent être du même type d\'analyse.');
                return of(null)
            }
        }

        return this.http.post<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/generateOT`, dto)
    }

      generateAnalyseResults(sampleAnalyseIds: number[]): Observable<any> {
    return this.http.post<any>(
      `${this.endPoint.analyseR_base_endpoint}/generate`,
      sampleAnalyseIds
    );
  }

    findAll(): Observable<CommonResponse> {
        return this.http.get<CommonResponse>(this.endPoint.analyse_base_endpoint)
    }

    findAllInProgressAnalyses1(username: string){
        return this.http.get<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/in-progress?username=${username}`)

    }
    findAllInProgressAnalysesStock(){
        return this.http.get<AnalyseDTO[]>(`${this.endPoint.analyse_base_endpoint}/in-progres`)

    }

    findAllInProgressAnalyses(username: string): Observable<CommonResponse> {
        // Appel à l'API pour récupérer les analyses en fonction de l'utilisateur
        return this.http.get<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/in-progress?username=${username}`);
      }
// service : AnalyseService
getAnalysesByUser(userId: number): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/user/${userId}`);
}


    findAllCalculatedAnalyses(username:String){
        return this.http.get<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/calculated?username=${username}`)

    }

     getMyAnalyses(username:String){
        return this.http.get<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/mes-analyses?username=${username}`)

    }

    findAllValidatedAnalyses(username:String){
        return this.http.get<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/validated?username=${username}`)

    }
    getChartData(duration: string): Observable<any[]> {
        console.log('Fetching chart data for duration:', duration);
        return this.http.get<any[]>(`${this.endPoint.analyse_base_endpoint}/analyse?duration=${duration}`).pipe(
          catchError(err => {
            console.error('Error fetching chart data:', err);
            return of([]); // Retourner un tableau vide en cas d'erreur
          })
        );
      }

      getSampleStatusCount(): Observable<{ 'En cours': number, 'Calcule': number, 'Valide': number }> {
        return this.http.get<{ 'En cours': number, 'Calcule': number, 'Valide': number }>(
          `${this.endPoint.analyse_base_endpoint}/statut`
        );
      }
      updateResultatFinale(id: number, resultatFinale: number): Observable<any> {
  return this.http.patch(`${this.endPoint.analyseR_base_endpoint}/${id}/resultat-finale`, 
    { resultatFinale }
  );
}
      updateAfficherRapport(id: number, afficher: boolean): Observable<any> {
  return this.http.patch(`${this.endPoint.analyseR_base_endpoint}/${id}/afficher-rapport`, { afficherDansRapport: afficher });
}
  getAnalyseResultsByStatut(statut: 'EN_COURS' | 'CALCULE' | 'VALIDE'): Observable<any[]> {
    console.log('📡 Appel API → getAnalyseResultsByStatut');
    console.log('➡️ Statut envoyé :', statut);

    return this.http.get<any[]>(`${this.endPoint.analyseR_base_endpoint}/by-statut/${statut}`).pipe(
      tap(response => {
        console.log('✅ Réponse getAnalyseResultsByStatut :', response);
        console.log('📊 Nombre de résultats reçus :', response?.length);
      })
    );
  }
    update(analyse: AnalyseDTO): Observable<CommonResponse> {
        return this.http.put<CommonResponse>(this.endPoint.analyse_base_endpoint, analyse)
    }
 updateE(analyse: AnalyseResult): Observable<CommonResponse> {
        return this.http.put<CommonResponse>(this.endPoint.analyse_base_endpoint, analyse)
    }
    affectUser(params : number[]) :Observable<CommonResponse>{
        return this.http.post<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/affectUser`, params)
    }

    delete(id: number) :Observable<CommonResponse>{
        return this.http.delete<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/${id}`)
    }

    recalculerMultipleResult(dtos: AnalyseResult[]) {
        return this.http.post<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/recalculate-Results`, dtos)
    }
    calculerMultipleResult(dtos: AnalyseResult[]) {
        return this.http.post<CommonResponse>(`${this.endPoint.analyse_base_endpoint}/calculate-Results`, dtos)
    }

    validateMultipleResult(sampleIds: number[]) {
        return this.http.post<CommonResponse>(
            `${this.endPoint.analyseR_base_endpoint}/validate-Results`, 
            sampleIds
        );
}
getAnalyseResultsBySample(sampleId: number) {
  return this.http.get<AnalyseResult[]>(`${this.endPoint.analyse_base_endpoint}/sample/${sampleId}/results`);
}


}
